import { api } from "../../../utils/api";

export const fetchBoqByProject = async (projectId) => {
  const res = await api.get(`/boq/project/${projectId}`);
  return res.data.data; // ✅ return only the payload
};

// Get BOQ by BOQID and list in array format
export const fetchBoqById = (boqId) => {
  return api.get(`/boq/${boqId}`).then((res) => res.data);
};

// Create BOQ
export const createBoqApi = async (data) => {
  const res = await api.post("/boq", data);
  return res.data;
};

//create boq items based on boq header
export const createBoqItemsApi = async (boqId, items) => {
  const res = await api.post(`/boq/${boqId}/items`, { items });
  return res.data;
};

// Delete BOQ item
export const deleteBoqItem = async (itemId) => {
  try {
    const res = await api.delete(`/boq/${itemId}/items`);
    return res.data; // expected { status: true, message: "Deleted" }
  } catch (err) {
    console.error("Delete BOQ item error:", err);
    throw err;
  }
};

// Update BOQ
export const updateBoqApi = (boqId, payload) => {
  api.put(`/boq/items/${boqId}`, payload).then((res) => res.data);
};

//fetching boqitem qty hitsory
export const fetchHistoryBoqItem = async (itemid) => {
  const res = await api.get(`/boq/items/${itemid}/history`);
  return res.data;
};

// Update BOQ Status
export const updateBoqStatusApi = (boqId, status) => {
  api.patch(`/boq/${boqId}/status`, { status }).then((res) => res.data);
};

// Upload BOQ Files
export const uploadBoqFileApi = async (boqId, formData) => {
  const res = await api.post(`/boq/${boqId}/upload`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return res.data;
};
//files fetch for boq header file
export const fetchBoqFilesApi = async (boqId) => {
  const res = await api.get(`/boq/${boqId}`);
  return res.data;
};
//files view for
export const viewBoqFileApi = async (id) => {
  return await api.get(`/boq/boq-files/view/${id}`, {
    responseType: "blob",
  });
};
//downlad boq header fils
export const downloadBoqHeaderFilesApi = async (id) => {
  return await api.get(`/boq/boq-files/download/${id}`, {
    responseType: "blob",
  });
};

//update boq items
export const bulkUpdateBoqItemsApi = async (boqId, data) => {
  return await api.put(`/boq/${boqId}/items/bulk-update`, data);
};
//item code update api
export const updateItemCodeApi = async (id, data) => {
  return api.patch(`/boq/boq-items/${id}/item-code`, data);
};

// hsn update
export const updateItemHsnApi = async (id, data) => {
  return api.patch(`/boq/boq-items/${id}/hsn`, data);
};

//delte file boqheader
export const deleteBoqFileApi = async (fileId) => {
  const res = await api.delete(`/boq/file/${fileId}`);
  return res.data;
};

// upload file for boq items
export const uploadBoqItemFileApi = async (boqId, formData, config = {}) => {
  const res = await api.post(`/boq/items/${boqId}/uploadFile`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
    ...config,
  });

  return res.data;
};

// fetch files boq items
export const fetchBoqItemFilesApi = async (itemId) => {
  const res = await api.get(`/boq/items/${itemId}/files`);
  return res.data;
};

//view boq items fils
export const viewBoqItemFilesApi = async (id) => {
  return await api.get(`/boq/boq-item-files/view/${id}`, {
    responseType: "blob",
  });
};

//downlad boq items fils
export const downloadBoqItemFilesApi = async (id) => {
  return await api.get(`/boq/boq-item-files/download/${id}`, {
    responseType: "blob",
  });
};

// delete file boq items
export const deleteBoqItemFileApi = async (fileId) => {
  const res = await api.delete(`/boq/files/${fileId}`);
  return res.data;
};

// Get Project Progress
export const fetchProjectProgress = (projectId) =>
  api.get(`/projects/projects/${projectId}/progress`).then((res) => res.data);

export const fetchItemHistory = (itemId) =>
  api.get(`/boq/items/${itemId}/history`).then((res) => res.data.data);

// item history by date
export const fetchItemHistoryByDate = (fromDate) =>
  api
    .get(`/boq/items/history/by-date`, {
      params: { from_date: fromDate },
    })
    .then((res) => res.data);

// Add BOQ Item Execution
export const addBoqItemExecution = async (payload) => {
  try {
    return await api.post("/boq/item-progress", payload);
  } catch (error) {
    throw error;
  }
};

export const fetchExecutionHistoryByDate = (boqItemId, fromDate) =>
  api
    .get("/boq/items/execution-history", {
      params: {
        boq_item_id: boqItemId,
        from_date: fromDate,
      },
    })
    .then((res) => res.data);

// 🔹 Approval Summary
export const fetchApprovalSummary = async () => {
  const res = await api.get("/boq/boq-items/approval-summary");
  return res.data; // already clean response
};

export const updateBoqItemStatus = async (id, status) => {
  console.log("CALLING:", `/boq-item-files/${id}/approve`);
  const res = await api.post(`/boq/boq-item-files/${id}/approve`, {
    status,
  });
  return res.data;
};

// 🔹 Fetch BOQ Items with file + status
export const fetchBoqItemsWithFiles = async (boqId) => {
  const res = await api.get(`/boq/${boqId}/items-with-files`);
  return res.data;
};
